import { render, staticRenderFns } from "./fclExtraDataGrid.vue?vue&type=template&id=8f701882&"
import script from "./fclExtraDataGrid.vue?vue&type=script&lang=js&"
export * from "./fclExtraDataGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f701882')) {
      api.createRecord('8f701882', component.options)
    } else {
      api.reload('8f701882', component.options)
    }
    module.hot.accept("./fclExtraDataGrid.vue?vue&type=template&id=8f701882&", function () {
      api.rerender('8f701882', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/components/grid/fclExtraDataGrid.vue"
export default component.exports